// Show a generated file (an invoice PDF) in a new tab.
//
// Browsers only allow window.open() straight from a tap or click. Opening it
// after waiting for the download is treated as an unwanted pop-up by Safari on
// iPad/iPhone, so the tab is opened first (blank) and pointed at the file once
// it arrives. If even that is blocked, the file opens in the current tab
// instead, where the browser's Back button returns to the app.
export const openBlobInNewTab = async (getBlob) => {
  const tab = window.open('', '_blank');
  try {
    const blob = await getBlob();
    const url = URL.createObjectURL(blob);
    if (tab) {
      tab.location.href = url;
    } else {
      window.location.assign(url);
    }
    // The tab keeps its own reference; free ours later.
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (error) {
    if (tab) tab.close();
    throw error;
  }
};
